import React, { useContext } from "react";
import { EstateContext } from "../../../../hooks/ContextStore";
import RealProperty from "./RealProperty/RealProperty";
import MineralIntests from "./RealProperty/components/MineralInterest/MineralInterest";

function RealEstate(props) {
  const { handleOpen } = props;

  return (
    <>
      <div id="real-property" className={`card h-100 card-custom `}>
        <RealProperty handleOpen={handleOpen} /> 
      </div>
    </>
  );
}

export default RealEstate;
